import { useSmartProp } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, ToggleControl, SelectControl, TextControl } from '@wordpress/components';

export const Inspector = () => {
    const [reverseCols, setReversCols] = useSmartProp('reverseCols');
    const [reverseMobile, setReversMobile] = useSmartProp('reverseMobile');
    const [smallMargin, setSmallMargin] = useSmartProp('smallMargin');
    const [hideMobile, setHideMobile] = useSmartProp('hideMobile');
    const [background, setBackground] = useSmartProp('background');
    const [sun, setSun] = useSmartProp('sun');
    const [sunMobile, setSunMobile] = useSmartProp('sunMobile');
    const [anchorId, setAnchorId] = useSmartProp('anchorId');

    return (
        <PanelBody title="Paramètres" initialOpen={true}>
            <PanelRow>
                <ToggleControl label="Colonnes inversées" checked={reverseCols} onChange={setReversCols} />
            </PanelRow>
            <PanelRow>
                <ToggleControl label="Inverser sur mobile" checked={reverseMobile} onChange={setReversMobile} />
            </PanelRow>
            <PanelRow>
                <ToggleControl label="Petite marge centrale" checked={smallMargin} onChange={setSmallMargin} />
            </PanelRow>
            <PanelRow>
                <ToggleControl
                    label="Cacher la deuxième colonne sur mobile"
                    checked={hideMobile}
                    onChange={setHideMobile}
                />
            </PanelRow>
            <PanelRow>
                <SelectControl
                    label="Couleur de fond"
                    value={background}
                    onChange={setBackground}
                    options={[
                        { value: 'white', label: 'Clair' },
                        { value: 'blue', label: 'Bleu' },
                    ]}
                />
            </PanelRow>
            <PanelRow>
                <ToggleControl label="Décoration soleil" checked={sun} onChange={setSun} />
            </PanelRow>
            {sun && (
                <PanelRow>
                    <ToggleControl label="Afficher le soleil sur mobile" checked={sunMobile} onChange={setSunMobile} />
                </PanelRow>
            )}
            <PanelRow>
                <TextControl label={'Ancre ID'} value={anchorId} onChange={setAnchorId} />
            </PanelRow>
        </PanelBody>
    );
};

export default Inspector;
